<!-- Quiz Starting Page -->
<section>

    <!-- Page Title -->
    <div class="title text-center">
        <h2 class="container title">Module {{moduleNumber}} - Quiz</h2>
    </div>

    <!-- Quiz Info -->
    <hr>
    <div class="content-box text-center">
        <h1 class="bold">You are about to take the quiz for Module {{moduleNumber}}. The quiz will be a mix of true/false and multiple choice questions. Note that there is no time limit to this quiz and you must get at least 80% to pass.</h1>
        <h1 class="bold">Click the button below to begin.</h1>
    </div>
    <mdb-icon fas icon="long-arrow-alt-down" class="arrow"></mdb-icon>

    <!-- Start Quiz Button -->
    <div class="container text-center">
        <button type="button" class="btn waves-dark w-75" (click)="startQuiz()">Start Quiz</button>
    </div>
</section>